import api from "./api";

export interface Auth {
    user: User;
    Token: string;
}

export interface User {
    IdUser: number;
    IdProfessional: null;
    Companies: null;
    Name: string;
    Email: string;
    Cpf: string;
    Phone: string;
    PlanId: number
    IdCompany: number
}


export const loginWithUserAndPassword = (email: string, password: string): Promise<Auth> => {
    return api
        .post("session/checkout-login", {
            email, password
        })
        .then((response) => {
            return response.data
        })
}



export const loginWithGoogle = (idUser: string, socialMedia: "google"): Promise<Auth> => {
    return api
        .post("session/checkout-login-social-media", {
            idUser, socialMedia
        })
        .then((response) => {
            return response.data
        })
}


export const loginWithToken = (token: string): Promise<Auth> => {
    return api
        .post("session/checkout-login-token", {
            token
        })
        .then((response) => {
            return response.data
        })
}